import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { useSelector } from 'react-redux';
import { zonesSelector, zonesListSelector } from '../../features/places/placesSlice';
import { Checkbox, Chip, FormControlLabel, Grid } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 200,
    },
    label: {
        margin: useTheme().spacing(1),
    },
    selectEmpty: {
        marginTop: useTheme().spacing(2),
    },
    margin: {
        margin: useTheme().spacing(1),
    },
    textField: {
        width: '25ch',
    },
    chip: {
        margin: useTheme().spacing(0.5),
    },
}));

const ZoneMultiSelect = ({ multiZones, setMultiZones, multiZoneIds, setMultiZoneIds }) => {
    const classes = useStyles();
    const zones = useSelector(zonesSelector);
    const zoneIdList = useSelector(zonesListSelector);
    const [allZones, setAllZones] = useState(false);

    const [zone, setZone] = useState("");
    const [zoneId, setZoneId] = useState("")
    const [zoneList, setZoneList] = useState([]);

    useEffect(() => {
        setZoneList(multiZones);
        setZone("");
    }, [multiZones]);

    const onZoneSelect = (e, newValue) => {
        setZone(newValue);
    }

    const onZoneIdChange = (e, newValue) => {
        setZoneId(newValue);
        if (multiZoneIds.indexOf(newValue) === -1) {
            setMultiZoneIds([...multiZoneIds, newValue]);
        }
        if (multiZones.indexOf(newValue) === -1 && newValue) {
            setMultiZones([...multiZones, zones[newValue].zone_name]);
            setZoneList([...multiZones, zones[newValue].zone_name]);
        }
    }

    const zoneDeselect = (chip) => {
        const index = multiZones.indexOf(chip);
        //console.log("MV delete", index);
        if (index !== -1) {
            let newv = [...multiZones];
            newv.splice(index, 1);
            let newa = [...multiZoneIds];
            newa.splice(index, 1);
            //console.log("newv", newv);
            setMultiZones(newv);
            setMultiZoneIds(newa);
            setZoneList(newv);
        }
    }

    const allZoneSelect = () => {
        if (!allZones) {
            let allzoneNames = [];
            zoneIdList.forEach(zid => allzoneNames.push(zones[zid].zone_name));
            setMultiZoneIds(zoneIdList);
            setMultiZones(allzoneNames);
        } else {
            setMultiZones([]);
            setMultiZoneIds([]);
        }
        setAllZones(!allZones)
    }

    const deselctAll = () => {
        setMultiZones([]);
        setMultiZoneIds([]);
        setAllZones(false);
    }

    return (
        <Grid container item>
            <Grid item sm={12}>
                <FormControl className={classes.formControl}>
                    <Autocomplete
                        id="vehicle"
                        style={{ width: 200 }}
                        options={[...zoneIdList, ""]}
                        getOptionLabel={(option) => option ? zones[option].zone_name : ""}
                        value={zoneId}
                        onChange={onZoneIdChange}
                        inputValue={zone}
                        onInputChange={onZoneSelect}
                        renderInput={(params) => <TextField variant="standard" {...params} label="Zones" />}
                    />
                </FormControl>

            </Grid>
            <Grid item sm={12}>
                <FormControlLabel
                    control={<Checkbox checked={allZones} onChange={allZoneSelect} name="All Zones" />}
                    label={<span style={{ color: 'DodgerBlue' }}>Select All Zones</span>}
                />
            </Grid>
            {
                allZones ?
                    <Chip
                        size="small"
                        label="All Zones Selected"
                        onDelete={deselctAll}
                        className={classes.chip}
                        key="all"
                        color="primary"
                        variant="outlined"
                    />
                    :
                    <Grid item sm={12}>
                        {zoneList.map((v, i) =>
                            <Chip
                                size="small"
                                label={v}
                                onDelete={() => zoneDeselect(v)}
                                className={classes.chip}
                                key={i}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                    </Grid>
            }
        </Grid>
    );
}

export default ZoneMultiSelect;